<template>
  <div>
    <!-- <div class="all_body"> -->
      <div class="myBZ">
        <div class="my_left">
          <div class="my_left_content">
            <div class="my_left_text" :class="{'activeLeft':activeLeft === 0}" @click="tableft(0,'/p/System')">操作系统</div>
            <div class="my_left_text" :class="{'activeLeft':activeLeft === 1}" @click="tableft(1,'/p/Personal')">个人中心</div>
            <div class="my_left_text" :class="{'activeLeft':activeLeft === 2}" @click="tableft(2,'/p/Collect')">我的收藏</div>
            <div class="my_left_text" :class="{'activeLeft':activeLeft === 3}" @click="tableft(3,'/p/Ccjf')">积分查询</div>
            <div class="my_left_text" :class="{'activeLeft':activeLeft === 4}" @click="tableft(4,'/p/Exchange')">积分兑换</div>
          </div>
        </div>
        <div class="my_right">
          <router-view />
        </div>
      </div>
    </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      activeLeft: "",
      ticket:''
    };
  },
  mounted() {
    this.$store.commit("settab", "");
    this.activeLeft = this.$store.state.navleft;
    this.ticket = localStorage.getItem('ticket');
    if(!this.ticket){
      this.$router.push("/Login");
    }
  },
  updated() {
    this.activeLeft = this.$store.state.navleft;
  },
  methods: {
    tableft(e, url) {
      this.$store.commit("setNavLeft", e);
      this.$router.push(url);
      this.active = this.$store.state.nav;
    }
  }
};
</script>

<style >
.myBZ {
  padding-left: 11%;
  margin-top: 50px;
  display: flex;
  background: #EFEFEF;
}
.my_left {
  width: 250px;
  height: 706px;
  margin-left: 40px;
  margin-top: 40px;
  background: #ffffff;
  margin-bottom: 100px;
}
.my_left_content{
    margin-top: 30px;
}
.my_left_text{
    width: 250px;
    height: 70px;
    padding: 25px 0;
    padding-left: 31px;
    font-size: 22px;
    color: #000000;
    cursor: pointer;
}
.activeLeft{
    color: #55B233;
    border-left: 5px solid #55B233;
    background: #F6F6F6;
}
.my_right {
  margin-top: 40px;
  margin-left: 18px;
  margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyLeft.vue